import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
    table: {
        // minWidth: 650,
        minHeight:100,
    },
}));

export default function GroupLists(props) {
    const { groups,onRowClick,isMain,GroupColor} = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000",
        minHeight:150,
        paddingBottom:"11px",
        paddingTop:"11px"
    }
    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer component={Paper} >
            <Table
                size="small" aria-label="a dense table" >
                <TableBody
                style={{padding:"0.5rem",}}
                >
                    {groups.map((row,i) => (
                        <TableRow key={row.i}
                            style={{
                                textAlign: "-webkit-center",
                                whiteSpace: "nowrap",
                                color: "#000",
                                backgroundColor:GroupColor?.id==row.id || GroupColor?.parentId==row.id ?GroupColor.color:  row?.color==-1? !isMain ? colors.amber[900] : colors.grey[300]:
                                '#'+row?.color.toString(16).padStart(6,'0'),
                                fontWeight: "bold",
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}
                           >
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.name}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
